import ActionsMenu from "../shared/components/ActionsMenu";
import ConfirmModal from "../shared/components/ConfirmModal";
import InfoModal from "../shared/components/InfoModal";
import NuevaReservaForm from "./components/NuevaReservaForm";
import Searcher from "./components/Searcher";
import moment from "moment";
import { getActions } from "./actions";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { fetchPiezasReservadas } from "../../../../redux/piezasReservadas";
import { API_PIEZAS_RESERVADAS } from "../shared/services/piezasReservadas";
import { toast } from "react-toastify";
import { setErrorMessage } from "../shared/helpers/functionalities";

export default function PiezasReservadas() {
  const dispatch = useDispatch();
  const [openReservarPieza, setOpenReservarPieza] = useState(false);
  const [openConfirmarQuitar, setOpenConfirmarQuitar] = useState(false);
  const [currentReserva, setCurrentReserva] = useState(null);
  const [filtered, setFiltered] = useState([]);
  const [buscador, setBuscador] = useState('');
  const [estadoPieza, setEstadoPieza] = useState('no');
  const piezasReservadas = useSelector((state) => state.piezas_reservadas);
  const estadoPiezaValues = [
    { key: 'todos', value: 'todos', label: 'Todos' },
    { key: 'no', value: 'no', label: 'No' },
    { key: 'si', value: 'si', label: 'Si' },
  ];

  useEffect(() => {
    dispatch(fetchPiezasReservadas());
  }, []);

  useEffect(() => {
    setFiltered(piezasReservadas);
    filterPiezasReservadas(buscador, estadoPieza);
  }, [piezasReservadas]);

  const filterPiezasReservadas = (searchTerm, estado) => {
    const searchQuery = searchTerm?.toLowerCase() || '';

    const filteredEntities = piezasReservadas.filter((pieza) => {
      let matchesEstado = false;
      let matchesSearch = false;

      if (estado === 'todos') {
        matchesEstado = true;
      } else if (estado === 'si') {
        matchesEstado = pieza.vendida;
      } else {
        matchesEstado = !pieza.vendida;
      }

      if(searchQuery === "") matchesSearch = true;
      else matchesSearch = pieza.id_referencia_plataforma == searchQuery;

      return matchesEstado && matchesSearch;
    });

    setFiltered(filteredEntities);
  };

  const handleAction = (action, id) => {
    if (action === "remove") {
      handleOpenRemoveReserve(id);
    }
  };

  const handleReservarPieza = async(data) => {
    const response = await API_PIEZAS_RESERVADAS.saveReserve(data)
    .catch(function (error) {
      dispatch({type: 'loading/set', payload: false});
      toast.error(setErrorMessage(error))
    });

    if(response && response.success) {
      toast.success(response.message);
      setOpenReservarPieza(false);
      dispatch(fetchPiezasReservadas());
    }
  };

  const handleOpenRemoveReserve = (id) => {
    setOpenConfirmarQuitar(true);
    setCurrentReserva(id);
  };
  const handleCloseRemoveReserve = () => {
    setOpenConfirmarQuitar(false);
    setCurrentReserva(null);
  }
  const handleQuitarReserva = async(confirm) => {
    if(confirm) {
      const response = await API_PIEZAS_RESERVADAS.quitReserve(
        currentReserva
      ).catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(response && response.success) {
        toast.success(response.message);
        dispatch(fetchPiezasReservadas());
      }
    }
    
    handleCloseRemoveReserve();
  };

  /** Render **/
  return (
    <>
      <div className="content pt-5">
        <h1 className="page-name">Piezas reservadas</h1>
        <div className="w-100 d-flex flex-column align-items-end content-table">
          <div className="d-flex align-items-center justify-content-between mb-3 w-100 flex-wrap gap-2">
            <div className="d-flex align-items-end gap-2 flex-wrap">
              <div>
                <small>Vendida</small>
                {(estadoPiezaValues?.length > 0) && (
                  <select
                    id="estadoPieza"
                    value={estadoPieza}
                    onChange={(e) => {
                      setEstadoPieza(e.target.value);
                      filterPiezasReservadas(buscador, e.target.value);
                    }}
                  >
                    {estadoPiezaValues?.map(estado => (
                      <option key={estado.key} value={estado.value}>
                        {estado.label}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <Searcher
                onSearch={({ buscador }) => {
                  setBuscador(buscador);
                  filterPiezasReservadas(buscador, estadoPieza);
                }}
              />
            </div>
            <button
              className="btn btn-info me-3"
              onClick={() => setOpenReservarPieza(true)}
            >
              Nueva reserva
            </button>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Id referencia plataforma</th>
                  <th>Pieza</th>
                  <th className="text-center">Vendida</th>
                  <th>Referencia</th>
                  <th className="text-center">Recambista</th>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Acciones</th>
                </tr>
              </thead>

              <tbody>
                {filtered?.map((pieza) => {
                  return (
                    <tr key={pieza.id_referencia_plataforma}>
                      <td># {pieza.id_referencia_plataforma}</td>
                      <td>{pieza.nombre}</td>
                      <td className="text-center">
                        <span className={"fw-bold " + (pieza.vendida ? 'text-green' : 'text-danger')}>
                          {pieza.vendida ? 'SI' : 'NO'}
                        </span>
                      </td>
                      <td>{pieza.referencia}</td>
                      <td className="text-center">{pieza.username || "-"}</td>
                      <td className="text-center">
                        {pieza.fecha ? moment(pieza.fecha).format('DD-MM-YYYY') : '-'}
                      </td>
                      <td className="text-center">
                        <ActionsMenu
                          options={getActions()}
                          onAction={(action) =>
                            handleAction(action, pieza.id_referencia_plataforma)
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {openReservarPieza && (
        <InfoModal
          state={openReservarPieza}
          title={"Marcar pieza como reservada"}
          content={<NuevaReservaForm onReservarPieza={handleReservarPieza} />}
          width={"sm"}
          onClose={() => setOpenReservarPieza(false)}
        />
      )}
      {openConfirmarQuitar && (
        <ConfirmModal
          state={openConfirmarQuitar}
          title={"Quitar reserva"}
          onConfirmAction={handleQuitarReserva}
          content={"Estas seguro de quitar esta reserva?"}
          width={"sm"}
          onClose={() => setOpenConfirmarQuitar(false)}
        />
      )}
    </>
  );
}
